import React, {useEffect, useState} from "react";
import s from "./PrintOptionsWrapper.module.css";
import "react-responsive-modal/styles.css";
import {Select} from "../../Select/select";
import {PAGES_SIZES_FOR_PROMOS} from "../../../constants/constants";
import {ButtonWrapper} from "../../Button/Button";
import {useSelector} from "react-redux";
import {Box, Typography} from "@mui/material";
import {Emoji} from "../../Emoji/Emoji";
import {makeStyles} from "@mui/styles";
import {useMediaQuery} from "react-responsive";

const useStyles = makeStyles(theme => ({
    caption: (props) => ({
        '& > .MuiTypography-root': {
            fontSize: props.isLaptop ? `14px` : `20px`,
            fontWeight: `bold`,
            marginLeft: `5px`,
        }
    })
}))

const PrintOptionsWrapper = (props) => {
    const {contentData} = useSelector(state => state);
    const isLaptop = useMediaQuery({ query: '(max-width: 1536px)' });
    const stylesProperties = {
        isLaptop: isLaptop
    }
    const classes = useStyles(stylesProperties);

    const [numberOfPages, setNumbersOfPages] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const [format, setFormat] = useState("");
    const [optionsForFormatDropdown, setOptionsForFormatDropdown] = useState([]);
    const [numberOfCopies, setNumberOfCopies] = useState(0);
    // const [supplier, setSupplier] = useState('');
    // const [product, setProduct] = useState('');
    const selectedOptionValue = localStorage.getItem("selectedOptionValue");
    // const format = props.format;

    useEffect(() => {
        let formatOptions = [];
        if (props.isActivePromotionScreen) {
            formatOptions = PAGES_SIZES_FOR_PROMOS.filter(key => key.code !== 'A4NinthLandscape');
        } else {
            formatOptions = PAGES_SIZES_FOR_PROMOS.filter(key => key.code !== 'A4QuarterPortrait' && key.code !== 'A4EighthPortrait');
        }
        setOptionsForFormatDropdown(formatOptions);
        props.setFormat('A4');
    }, [props.isActivePromotionScreen])

    useEffect(() => {
        setFormat(props.format);
    }, [props.format]);

    useEffect(() => {
        let copies = 1;
        let selectedRowsArray;
        if (contentData.isActivePromosScreen) {
            if (contentData.isPrintListOpened) {
                selectedRowsArray = [...contentData.printListDataForPromos]
                    .filter((row) => {
                        if (row.selectedRow) {
                            return row;
                        }
                    })
                    .map((row) => {
                        copies += row.numberOfCopies - 1;
                        return row.SaleIdentifier;
                    });
            } else {
                selectedRowsArray = [...contentData.data]
                    .filter((row) => {
                        if (row.selectedRow) {
                            return row;
                        }
                    })
                    .map((row) => {
                        copies += row.numberOfCopies - 1;
                        return row.SaleIdentifier;
                    });
            }
        } else {
            if (contentData.isPrintListOpened) {
                selectedRowsArray = [...contentData.printListDataForItems]
                    .filter((row) => {
                        if (row.selectedRow) {
                            return row;
                        }
                    })
                    .map((row) => {
                        copies += row.numberOfCopies - 1;
                        return row.EffectiveBarCode;
                    });
            } else {
                selectedRowsArray = [...contentData.dataForRegPrices]
                    .filter((row) => {
                        if (row.selectedRow) {
                            return row;
                        }
                    })
                    .map((row) => {
                        copies += row.numberOfCopies - 1;
                        return row.EffectiveBarCode;
                    });
            }
        }
        setNumberOfCopies(copies);
        setSelectedRows(selectedRowsArray);
    }, [
        contentData.data,
        contentData.dataForRegPrices,
        contentData.printListDataForPromos,
        contentData.printListDataForItems,
        contentData.isPrintListOpened,
        contentData.isActivePromosScreen
    ]);

    useEffect(() => {
        // if(props.isActivePromotionScreen){
        //     setSupplier(props.dropDownValues.supplierValues.promos);
        //     setProduct(props.dropDownValues.productCategoryValues.promos);
        // } else {
        //     setSupplier(props.dropDownValues.supplierValues.prices);
        //     setProduct(props.dropDownValues.productCategoryValues.prices);
        // }
        props.setSupplier("");
        props.setProduct("");
    }, [props.supplierNames, props.productCategoryNames]);

    useEffect(() => {
        if (selectedRows.length) {
            let newNumbersOfSelectedPages = 0;
            switch (props.format) {
                case "A4QuarterPortrait":
                case "A4QuarterLandscape":
                    newNumbersOfSelectedPages = Math.ceil(
                        Number((selectedRows.length + numberOfCopies - 1) / 4)
                        // Number(selectedRows.length / 4)
                    );
                    break;
                case "A4EighthPortrait":
                    newNumbersOfSelectedPages = Math.ceil(
                        Number((selectedRows.length + numberOfCopies - 1) / 8)
                    );
                    break;
                case "A4NinthLandscape":
                    newNumbersOfSelectedPages = Math.ceil(
                        Number((selectedRows.length + numberOfCopies - 1) / 9)
                    );
                    break;
                default:
                    newNumbersOfSelectedPages = (selectedRows.length + numberOfCopies - 1);
            }
            setNumbersOfPages(newNumbersOfSelectedPages);
        } else {
            setNumbersOfPages(0);
        }
    }, [contentData.data,
        contentData.dataForRegPrices,
        contentData.printListDataForPromos,
        contentData.printListDataForItems,
        contentData.isPrintListOpened,
        contentData.isActivePromosScreen
        , format, selectedRows]);
    const branchNo = localStorage.getItem("selectedOptionValue");

    // const formatOptions = ['A4', 'A4 1/4 Portrait', 'A4 1/4 Landscape', 'A4 1/8'];

    if (props.isDataPrintForButton) {
        if (props.isActivePromotionScreen) {
            const onAfterPrint = () => {
                const format = props.format;
                const selectedRowsIds = props.selectedIds;
                const branchNo = localStorage.getItem("selectedOptionValue");
                props.sendSaleIds(branchNo, format, selectedRowsIds);
            };
            const a = window.open("", "");
            if (a) {
                a.document.write(props.dataForPrint);
                a.onafterprint = onAfterPrint;
                props.setDataPrintStatus(false);
            }
        } else {
            const onAfterPrint = () => {
                const format = props.format;
                const selectedRowsEffectiveBarCodes = props.selectedIds;
                const branchNo = localStorage.getItem("selectedOptionValue");
                props.sendEffectiveBarCodes(
                    branchNo,
                    format,
                    selectedRowsEffectiveBarCodes
                );
            };
            const a = window.open("", "");
            if (a) {
                a.document.write(props.dataForPrint);
                a.onafterprint = onAfterPrint;
                props.setDataPrintStatus(false);
            }
        }
    }
    let getDataForPrint = () => {
        if (props.isActivePromotionScreen) {
            if (contentData.isPrintListOpened) {
                props.changeSelectedIds(selectedRows);
                const selectedRowsDataForDownload = [...contentData.printListDataForPromos]
                    .filter((row) => {
                        if (selectedRows.includes(row.SaleIdentifier)) {
                            return row;
                        }
                    })
                    .map((row) => {
                        return {
                            SaleIdentifier: row.SaleIdentifier,
                            NoSigns: row.numberOfCopies,
                        };
                    });
                props.onDownload(format, selectedRowsDataForDownload, branchNo, false);
            } else {
                props.changeSelectedIds(selectedRows);
                const selectedRowsDataForDownload = [...contentData.data]
                    .filter((row) => {
                        if (selectedRows.includes(row.SaleIdentifier)) {
                            return row;
                        }
                    })
                    .map((row) => {
                        return {
                            SaleIdentifier: row.SaleIdentifier,
                            NoSigns: row.numberOfCopies,
                        };
                    });
                props.onDownload(format, selectedRowsDataForDownload, branchNo, false);
            }
        } else {
            if (contentData.isPrintListOpened) {
                props.changeSelectedIds(selectedRows);
                const selectedRowsDataForDownload = [...contentData.printListDataForItems]
                    .filter((row) => {
                        if (selectedRows.includes(row.EffectiveBarCode)) {
                            return row;
                        }
                    })
                    .map((row) => {
                        return {
                            EffectiveBarCode: row.EffectiveBarCode,
                            NoSigns: row.numberOfCopies,
                        };
                    });
                props.onDownloadRegItems(
                    format,
                    selectedRowsDataForDownload,
                    branchNo,
                    false
                );
            } else {
                props.changeSelectedIds(selectedRows);
                const selectedRowsDataForDownload = [...contentData.dataForRegPrices]
                    .filter((row) => {
                        if (selectedRows.includes(row.EffectiveBarCode)) {
                            return row;
                        }
                    })
                    .map((row) => {
                        return {
                            EffectiveBarCode: row.EffectiveBarCode,
                            NoSigns: row.numberOfCopies,
                        };
                    });
                props.onDownloadRegItems(
                    format,
                    selectedRowsDataForDownload,
                    branchNo,
                    false
                );
            }
        }
    };
    let onSetFormat = (e) => {
        const value = e.target.value;
        props.setFormat(value);
    };

    let onSetSupplier = (e) => {
        const value = e.target.value;
        props.setPreloader(true);
        if (props.isActivePromotionScreen) {
            props.setSupplier(value);

            const format = props.format;
            const supplierName = value === "" ? null : value;
            const productCategoryName = props.product === "" ? null : props.product;
            // const productCategoryName = props.dropDownValues.productCategoryValues.promos
            props.getDataTable(
                selectedOptionValue,
                format,
                supplierName,
                productCategoryName,
                contentData.searchValue,
                true,
            );
        } else {
            props.setSupplier(value);
            const format = props.format;
            const supplierName = value === "" ? null : value;
            const productCategoryName = props.product === "" ? null : props.product;
            // const productCategoryName = props.dropDownValues.productCategoryValues.prices
            props.getDataTableForRegularPrices(
                selectedOptionValue,
                format,
                supplierName,
                productCategoryName,
                contentData.searchValue,
                true
            );
        }
    };
    let onSetProductCategory = (e) => {
        const value = e.target.value;
        props.setPreloader(true);
        if (props.isActivePromotionScreen) {
            props.setProduct(value);

            const format = props.format;
            const supplierName = props.supplier === "" ? null : props.supplier;
            // const supplierName = props.dropDownValues.supplierValues.promos;
            const productCategoryName = value === "" ? null : value;
            props.getDataTable(
                selectedOptionValue,
                format,
                supplierName,
                productCategoryName,
                contentData.searchValue,
                true
            );
        } else {
            props.setProduct(value);

            const format = props.format;
            const supplierName = props.supplier === "" ? null : props.supplier;
            // const supplierName = props.dropDownValues.supplierValues.prices;
            const productCategoryName = value === "" ? null : value;
            props.getDataTableForRegularPrices(
                selectedOptionValue,
                format,
                supplierName,
                productCategoryName,
                contentData.searchValue,
                true
            );
        }
    };

    return (
        <div className={s.wrapper}>
            {
                contentData.isPrintListOpened ?
                    <Typography color={`#FFC700`} fontSize={`25px`} fontWeight={`bold`} sx={{width: `40%`}}
                                textAlign={`center`}>
                        רשימת הדפסה
                    </Typography> :
                    <>
                        <div className={s.printOption}>
                            <div className={s.pageFormatWrapper}>
                                <Box className={classes.caption}>
                                    <Typography>
                                        מחלקה:
                                    </Typography>
                                </Box>
                                <div>
                                    <Select
                                        value={props.product}
                                        onChange={onSetProductCategory}
                                        options={props.productCategoryNames}
                                        selectedOption={props.product}
                                        isHasEmptyOption={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={s.printOption}>
                            <div className={s.pageFormatWrapper}>
                                <Box className={classes.caption}>
                                    <Typography>
                                        ספק:
                                    </Typography>
                                </Box>
                                <div>
                                    <Select
                                        value={props.supplier}
                                        onChange={onSetSupplier}
                                        options={props.supplierNames}
                                        selectedOption={props.supplier}
                                        isHasEmptyOption={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
            }

            <div className={s.printOption}>
                <div className={`${s.pageFormatWrapper}`}>
                    <Box className={classes.caption}>
                        <Typography>
                            סוג השילוט:
                        </Typography>
                    </Box>
                    <div className={s.selectWrapper}>
                        <Select
                            value={format}
                            onChange={onSetFormat}
                            options={optionsForFormatDropdown}
                            selectedOption={format}
                            isHasEmptyOption={false}
                        />
                    </div>
                </div>
            </div>
            <div className={s.printOptionWrapper}>
                {selectedRows.length > 0 && numberOfPages > 0 ? (
                    <div className={s.numberOfPagerWrapper}>
                        <Box className={classes.caption}>
                            <Typography>
                                עמודים להדפסה:
                            </Typography>
                        </Box>
                        <Box className={classes.caption} title={numberOfPages > 500 ? 'The maximum number of printed pages must be 500 pages or less' : ''}>
                            <Typography color={numberOfPages > 500 ? 'red' : 'white'} fontSize={isLaptop ? `14px` : `24px`}>
                                {numberOfPages}
                            </Typography>
                        </Box>
                        {
                            numberOfPages > 500 &&
                            <Box sx={{height: `100%`}}
                                 title={numberOfPages > 500 ? 'The maximum number of printed pages must be 500 pages or less' : ''}>
                                <Emoji label="fear" symbol="😱" fontSize={`25px`}/>
                            </Box>
                        }
                    </div>
                ) : null}

                <ButtonWrapper
                    onClick={getDataForPrint}
                    value="הדפסת שלטים נבחרים"
                    icon="print"
                    data={props.data}
                    numberOfPages={numberOfPages}
                />
            </div>
        </div>
    );
};

export default PrintOptionsWrapper;
